import React from "react";
import "./GridTableFilterRow.scss";

export type HeaderData = {
  sortDirection: "DESC" | "ASC" | undefined;
  onSort: (ctrlClick: boolean) => void;
  column: { name: React.ReactNode; sortable: boolean };
};

export const GridTableFilterRow: React.FC<{
  header: HeaderData;
  children?: React.ReactNode;
}> = ({ header, children }) => {
  return (
    <div className="flex flex-col">
      <div
        className={`flex flex-row justify-between ${header.column.sortable ? "cursor-pointer" : ""}`}
        onClick={header.column.sortable ? () => header.onSort(false) : undefined}
      >
        <div>{header.column.name}</div>
        <span>
          {header.column.sortable
            ? header.sortDirection === undefined
              ? ""
              : header.sortDirection === "DESC"
              ? "▲"
              : "▼"
            : ""}
        </span>
      </div>
      {children ?? null}
    </div>
  );
};
